import script from "./ReviewTransferStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewTransferStep.vue?vue&type=script&setup=true&lang=js"

import "./ReviewTransferStep.vue?vue&type=style&index=0&id=7d6c5df2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d6c5df2"]])

export default __exports__